import { apiClient } from "../config";

async function archiveOrRestoreCondition(id: any, status: any) {
  const url = `/admin/conditions/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreCondition;
